
import { computed, defineComponent, onMounted, watch } from "vue";
import LoginCard from "@/components/LoginCard.vue";
import { View } from "@/enums";
import { store } from "@/store/LoginDataStore";
import { loginApi } from "@/http/api_calls/LoginApi";
import { useParameterStore } from "@/logic/parameters";
import { useCookieStore } from "@/logic/cookies";
import { GpcSpinnerComponent } from "gpc-vue3-components";

export default defineComponent({
  name: "App",
  components: {
    LoginCard,
    GpcSpinnerComponent,
  },
  setup() {
    const { readCookiesToStore, createCookiesFromStore } = useCookieStore();
    const { readParametersToStore } = useParameterStore();
    const state = store.getState();

    const showSpinner = computed(() => state.isLoading);
    watch(
      () => state.errorMessage,
      (errorMessage) => {
        if (errorMessage !== "") {
          store.setIsLoading(false);
        }
      }
    );

    const isSSOProviderRequest = async () => {
      return await loginApi.isSSOProviderRequest();
    };

    const selectView = async () => {
      readCookiesToStore();
      readParametersToStore();

      if (state.successMessage) {
        store.setView(View.USERINFO);
        return;
      }

      const username = state.username;
      const customerId = state.customerId;

      if (username && customerId) {
        if (await isSSOProviderRequest()) {
          store.setView(View.PASSWORD);
          return;
        }
        if (!state.errorMessage) {
          let redirectUrl = await loginApi.getRedirectUrl(customerId, username);
          window.location.replace(redirectUrl);
        }
      }

      const password = state.password;
      createCookiesFromStore(username, customerId, password);
      store.setView(View.USERINFO);
    };

    const loadInfraUrls = async () => {
      if (state.clientIds) {
        const infraUrls = await loginApi.getInfraUrlsForClientIds(
          state.clientIds
        );
        store.setInfraUrls(infraUrls);
      }
    };

    onMounted(async () => {
      selectView();
      await loadInfraUrls();
    });

    return { showSpinner };
  },
});
